import { useEffect, useState } from "react";
import { getAllActs } from "../../../../../API/Mediatheque/Administration/actService";
import BreadCrumb from "../../../../../components/breadcrumb";
import Header from "../../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../../components/DashboardNavigation/sidebar";
import { AdministrationData } from "../../../../../components/tables/administration-tables/Administration";

const breadcrumbItems = [
  {
    title: "Actes administratifs",
    link: "/admin-dashboard/mediatheque/actes-administratifs",
  },
];
export default function Administration() {
  const [acts, setActs] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllActs();
    setActs(response?.acts);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <AdministrationData data={acts} />
        </div>
      </div>
    </>
  );
}
